<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <Windelete ref="windelete" @get_kcop="get_kcops()" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Заявки КЦОП (Всего заявок:  {{ kcops_count }})
            </div><br>
            <div class="btn_add" @click="$router.push('/kcop/new')">Подать заявку на КЦОП</div>
            <div class="btn_add" style="margin-top: -20px !important;" @click="$router.push('/summary')">Сводная ведомость</div>
            <!-- отображать архивные заявки -->
            <div style="display: block;">
                <input type="checkbox" v-model="is_archive" name="is_archive" style="width: 20px !important; height: 20px !important; display: inline-block; vertical-align: top;" @change="get_kcops()" />
                <label for="is_archive" style="display: inline-block !important; margin-top: 4px; margin-left: 10px;">Показывать архивные заявки {{ is_archive }}</label>
            </div>
            <br />
            <table>
                <tr>
                    <th>ID Заявки</th>
                    <th>Компания</th>
                    <th>Пользователь</th>
                    <th>
                        <div v-show="permissions.show_kcop_filters">
                            Статус<br>
                            <select v-model="status_id" @change="get_kcops()">
                                <option value="-1">Все статусы</option>
                                <option v-for="key, index in ref_statuses" :key="index" :value="index">{{ key }}</option>
                            </select>
                        </div>
                    </th>
                    <th>
                        <div v-show="permissions.show_kcop_filters">
                            Доп. статус<br>
                            <select v-model="ext_status" @change="get_kcops()">
                                <option value="-1">Все статусы</option>
                                <option v-for="key, index in ref_ext_statuses" :key="index" :value="index">{{ key }}</option>
                            </select>
                        </div>
                    </th>
                    <th></th>
                </tr>
                <tr v-for="kcop in kcops" :key="kcop.id">
                    <td>{{ kcop.id }}</td>
                    <td>
                        {{ kcop.company }} <br>
                        <div style="margin-top: 10px;">
                            <b>ИНН: </b>{{ kcop.inn }} <br>
                            <b>Адрес: </b>{{ kcop.address }}<br>
                            <b>Регион: </b>{{ ref_regions[kcop.region_id] }}
                        </div>
                        <div v-show="permissions.show_kcop_filters" style="color: blue; margin-top: 10px; cursor: pointer;" @click="set_in_archive(kcop.id)">
                            <div v-if="kcop.is_archive == 0">В архив</div>
                            <div v-if="kcop.is_archive == 1">Из архива</div>
                        </div>

                    </td>
                    <td>
                        {{ kcop.user }}
                        <div style="margin-top: 10px;">
                            <b>Email: </b> {{ kcop.email }}<br>
                            <b>Телефон: </b> {{ kcop.phone }}<br>
                            <b>Должность: </b> {{ kcop.position }}<br>
                        </div>
                    </td>
                    <td>{{ ref_statuses[kcop.status_id] }}</td>
                    <td>{{ ref_ext_statuses[kcop.ext_status] }}</td>
                    <td>
                        <Btn_edit @click="$router.push('/kcop/edit/'+kcop.id)"/>
                        <Btn_upload v-show="permissions.kcop_upload_files" @click="$router.push('/kcop/upload/'+kcop.id)"/>
                        <Btn_delete v-show="permissions.kcop_delete_req" @click="delete_kcop_window(kcop.id)"/>
                    </td>
                </tr>
            </table>
            <div class="data_empty_in_table" v-show="isTableArrayShow">
                    Нет созданных заявок
            </div>
            <div class="pagination">
            <button @click="pagination_prev()">&#8592; Назад</button>
            <button @click="pagination_next()">Вперед &#8594;</button>
            </div>
        </div>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Btn_edit from '@/components/elements/svg/btn_edit.vue'
import Btn_upload from '@/components/elements/svg/btn_upload.vue'
import Btn_delete from '@/components/elements/svg/btn_delete.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Windelete from '@/components/windows/win_delete.vue'

export default {
    name: 'Kcop',
    components: {
        Success, Error, Btn_edit, Btn_upload, Btn_delete, Backbutton, Windelete
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            kcops: {},
            kcops_count: 0,
            start: 0,
            take: 30,
            status_id: -1,
            ext_status: -1,
            is_archive: 0,
            ref_statuses: {
                1: 'На рассмотрении',
                2: 'Зарегистрировано',
                3: 'Отклонено',
            },
            ref_ext_statuses: {
                0: 'Не установлен',
                1: 'Допущено к защите',
                2: 'Победитель конкурсного отбора'
            },
            ref_regions: [],
            ref_cities: [],
            permissions: {}
        }
    },
    computed: {
        isTableArrayShow: function() {
            if(this.kcops.length > 0)
                return false
            else    
                return true
        }
    },
    methods: {
        delete_kcop_window(kcop_id) {
            //windelete
            this.$refs.windelete.kcop_id = kcop_id
            this.$refs.windelete.is_window_show = true
        },
        pagination_next() {
            if((this.start + 1)*this.take < this.kcops_count) {
                this.start = this.start + 1
                this.get_kcops()
            }
        },
        pagination_prev() {
            if((this.start) >= 1) {
                this.start = this.start - 1
                this.get_kcops()
            }
        },
        set_in_archive(id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/set_in_archive/' + id)
                .then(response => {
                    console.log(response.data.data)
                    this.get_kcops()
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_kcops() {
            let start_record = this.start * this.take
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcops/'+start_record+'/'+this.take+'/'+this.status_id+'/'+this.ext_status+'/'+this.is_archive)
                .then(response => {
                    this.kcops = response.data.data
                    this.kcops_count = response.data.kcops_count  
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_ref_regions() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/refbook/regions')
            .then(response => {
                let ref_regions = response.data.data  
                let tmp_array = [] 
                ref_regions.forEach(element => {
                    tmp_array[element.id] = element.name 
                });
                this.ref_regions = tmp_array
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
    },
    created() {
        this.permissions =  JSON.parse(localStorage.getItem('permissions'))
        this.get_ref_regions()
        this.get_kcops()
    }
}

</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>